<template>
  <div class="denuncia-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-2 mx-sm-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0 d-none d-sm-block">Centro de Atención y Reclamos Institucionales</p>
                <p class="text-caption grey--text text--darken-1 mb-0 d-block d-sm-none">Centro de Atención</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-shield-alert-outline</v-icon>
          </div>
        </div>

      <!-- Main Content -->
      <v-card class="glass-card rounded-xl overflow-hidden mx-2 mx-sm-4 mb-4" elevation="10">
        <v-tabs v-model="tab" background-color="transparent" color="primary" grow class="premium-tabs">
          <v-tab class="font-weight-bold"><v-icon left>mdi-plus-circle-outline</v-icon> Nueva Denuncia</v-tab>
          <v-tab class="font-weight-bold"><v-icon left>mdi-history</v-icon> Mis Denuncias</v-tab>
        </v-tabs>

        <div class="transparent-bg pa-4">
          
          <!-- TAB 1: NUEVA DENUNCIA -->
          <div v-show="tab === 0">
            <v-alert
              border="left"
              colored-border
              color="info"
              elevation="2"
              class="mb-6 rounded-lg glass-alert"
              icon="mdi-information-outline"
            >
              <div class="text-body-2">
                <strong>Lea con atención:</strong> Esta sección solo acepta denuncias respecto al trabajo y trato del personal de la institución. Las denuncias deben ser personales, es decir a una única persona, y clarificar los hechos sucedidos. Si no cumple, la denuncia será desestimada. Toda denuncia de otra índole o consulta debe ser canalizada por el lugar correspondiente, en 
                <a class="info--text font-weight-bold" href="tramite">Consultas</a>.
              </div>
            </v-alert>

            <v-form ref="formDenuncia" class="premium-form px-2">
              <v-row>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="titulo"
                    label="Describa en pocas palabras su denuncia (Título)"
                    outlined
                    dense
                    rounded
                    color="primary"
                    prepend-inner-icon="mdi-format-title"
                    class="glass-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="prioridad"
                    :items="prioridades"
                    item-text="text"
                    item-value="value"
                    label="Nivel de Prioridad"
                    outlined
                    dense
                    rounded
                    return-object
                    color="primary"
                    prepend-inner-icon="mdi-alert-circle-outline"
                    class="glass-input"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip small :color="getPrioridadColor(item.value)" dark class="font-weight-bold">
                        {{ item.text }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="texto"
                    label="Describa detalladamente los hechos sucedidos"
                    outlined
                    auto-grow
                    rows="4"
                    rounded
                    color="primary"
                    prepend-inner-icon="mdi-text-box-outline"
                    class="glass-input"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    v-model="tipo"
                    :items="types"
                    item-text="text"
                    item-value="value"
                    label="Denunciar a (Rol):"
                    outlined
                    dense
                    rounded
                    return-object
                    color="primary"
                    prepend-inner-icon="mdi-account-group-outline"
                    class="glass-input"
                    @change="getUsers"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-if="tipo && tipo.value !== '3'"
                    v-model="persons"
                    :items="allpersons"
                    item-text="nombre"
                    item-value="id"
                    label="Selecciona a quién denunciar"
                    multiple
                    outlined
                    dense
                    rounded
                    chips
                    small-chips
                    deletable-chips
                    color="primary"
                    prepend-inner-icon="mdi-account-search-outline"
                    class="glass-input"
                  ></v-autocomplete>

                  <v-text-field
                    v-else-if="tipo && tipo.value === '3'"
                    v-model="otroCampo"
                    label="Escriba a quién quiere denunciar"
                    outlined
                    dense
                    rounded
                    color="primary"
                    prepend-inner-icon="mdi-account-edit-outline"
                    class="glass-input"
                  ></v-text-field>
                </v-col>
              </v-row>

              <div class="d-flex justify-end mt-4">
                <v-btn
                  color="success"
                  elevation="8"
                  large
                  rounded
                  class="px-8 font-weight-bold btn-gradient"
                  @click="addDenuncia()"
                >
                  <v-icon left>mdi-send-check</v-icon>
                  Enviar Denuncia
                </v-btn>
              </div>
            </v-form>
          </div>

          <!-- TAB 2: MIS DENUNCIAS -->
          <div v-show="tab === 1">
            <div v-if="!denunciasUser.length" class="text-center pa-10">
              <v-icon size="80" color="grey lighten-2">mdi-inbox-outline</v-icon>
              <h3 class="text-h6 grey--text mt-4">No tienes denuncias registradas</h3>
            </div>
            
            <v-row v-else>
              <v-col cols="12" md="6" lg="4" v-for="(denuncia, index) in denunciasUser" :key="index">
                <v-card class="denuncia-card rounded-xl" elevation="4" outlined>
                  <div class="card-header d-flex justify-space-between align-center pa-4 pb-0">
                    <v-chip small :color="getEstadoColor(denuncia.estado)" dark class="font-weight-bold">
                      {{ getEstadoText(denuncia.estado) }}
                    </v-chip>
                    <span class="text-caption grey--text font-weight-medium">
                      <v-icon small class="mr-1">mdi-calendar</v-icon>{{ denuncia.tiempo }}
                    </span>
                  </div>
                  
                  <v-card-title class="text-h6 font-weight-bold pb-2 line-clamp-2">
                    {{ denuncia.titulo }}
                  </v-card-title>
                  
                  <v-card-actions class="pa-4 pt-0 d-flex justify-space-between align-end">
                    <v-dialog v-if="denuncia.respuesta" v-model="dialogs[denuncia.id]" width="600" overlay-color="black" overlay-opacity="0.8">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small rounded color="primary" outlined v-bind="attrs" v-on="on" class="glass-btn-small">
                          <v-icon left small>mdi-message-text-outline</v-icon> Ver Respuesta
                        </v-btn>
                      </template>
                      <v-card class="rounded-xl overflow-hidden glass-card">
                        <v-card-title class="primary white--text d-flex justify-space-between align-center">
                          Respuesta a la denuncia
                          <v-btn icon dark @click="$set(dialogs, denuncia.id, false)"><v-icon>mdi-close</v-icon></v-btn>
                        </v-card-title>
                        <v-card-text class="pa-6 text-body-1">
                          <div class="respuesta-content pa-4 rounded-lg grey lighten-4">
                            {{ denuncia.respuesta }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <div v-else class="text-caption grey--text">
                      Sin respuesta aún
                    </div>

                    <v-btn icon color="error" class="glass-btn-icon" @click="deleteDenuncia(denuncia.id)" title="Dar de baja">
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </div>

        </div>
      </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Denuncia",
  components: {
    CardIeaAppMain,
  },

  data: () => ({
    title: "Denuncias Institucionales",
    tab: 0,
    titulo: '',
    texto: '',
    prioridad: null,
    otroCampo: '',
    prioridades: [
      { text: 'Baja', value: '0' },
      { text: 'Media', value: '1' },
      { text: 'Alta', value: '2' },
      { text: 'Emergencia', value: '3' },
    ],
    types: [
      { text: 'Profesor', value: '1' },
      { text: 'Administrativo/Cobrador', value: '2' },
      { text: 'Otros', value: '3' },
    ],
    tipo: null,
    persons: [],
    allpersons: [],
    denunciasUser: [],
    dialogs: {},
  }),

  methods: {
    getEstadoText(estado) {
      if (estado == '0') return 'Sin atender';
      if (estado == '1') return 'En proceso';
      if (estado == '2') return 'Resuelto';
      if (estado == '3') return 'Desestimado';
      return 'Desconocido';
    },
    getEstadoColor(estado) {
      if (estado == '0') return 'grey darken-1';
      if (estado == '1') return 'orange darken-1';
      if (estado == '2') return 'success';
      if (estado == '3') return 'error';
      return 'grey';
    },
    getPrioridadColor(value) {
      if (value == '0') return 'info';
      if (value == '1') return 'warning';
      if (value == '2') return 'orange darken-4';
      if (value == '3') return 'error';
      return 'primary';
    },

    async addDenuncia() {
      let titulo = this.titulo;
      let texto = this.texto;
      let nivel = this.prioridad ? this.prioridad.value : '';
      let otroCampo = this.otroCampo;
      
      let dataSend = {
        titulo: titulo,
        texto: texto,
        nivel: nivel,
      };

      if (titulo.trim() == '' || texto.trim() == '' || nivel === '') {
        alert('Por favor llena todos los campos obligatorios (Título, Prioridad, Texto).');
        return;
      }
      
      if (!this.tipo) {
        alert('Por favor selecciona a quién denunciar.');
        return;
      }

      if (this.tipo.value == '3') {
        if (otroCampo.trim() == '') {
          alert('Escriba el nombre de la persona que denuncia.');
          return;
        } else {
          dataSend.otroCampo = otroCampo;
          dataSend.otroCheck = 1;
        }
      } else {
        if (this.persons.length == 0) {
          alert('Selecciona por lo menos una persona a denunciar.');
          return;
        } else {
          dataSend.usuarios = this.persons;
        }
      }

      let url = "reclamos/store";
      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then(() => {
          this.titulo = '';
          this.texto = '';
          this.prioridad = null;
          this.tipo = null;
          this.persons = [];
          this.otroCampo = '';
          this.tab = 1; 
          this.loadDenuncias();
        }).catch(err => {
          console.error("Error al crear denuncia", err);
        });
    },

    async deleteDenuncia(id) {
      if (confirm('¿Está seguro de que desea dar de baja esta denuncia?')) {
        let url = "reclamos/baja/" + id;
        await this.$API
          .post({
            url: url,
          }).then(() => {
            this.loadDenuncias();
          });
      }
    },

    async loadDenuncias() {
      let url = "reclamos/index";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.denunciasUser = res;
        });
    },

    async getUsers(sel) {
      this.persons = [];
      if (sel && sel.value !== '3') {
        let url = "reclamos/tipo-usuario/" + sel.value;
        await this.$API
          .get({
            url: url
          }).then((res) => {
            this.allpersons = res;
          });
      }
    }
  },

  mounted() {
    if (this.$store.getters.user.borrado == 1 || this.$store.getters.user.alumno_mora == true || this.$store.getters.user.excedente) {
      this.$router.push({
        name: "Home"
      });
    }
    this.loadDenuncias();
  },
};
</script>

<style scoped>
.denuncia-container {
  min-height: 100vh;
  padding-bottom: 40px;
  background-color: #f8fafc;
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08) !important;
}

.glass-alert {
  background: rgba(232, 244, 253, 0.8) !important;
  backdrop-filter: blur(5px) !important;
  border: 1px solid rgba(33, 150, 243, 0.2) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.glass-btn-icon {
  background: rgba(244, 67, 54, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  transition: all 0.3s ease;
}
.glass-btn-icon:hover {
  background: rgba(244, 67, 54, 0.2) !important;
  transform: scale(1.1);
}

.btn-gradient {
  background: linear-gradient(135deg, #4caf50 0%, #2e7d32 100%) !important;
  color: white !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.btn-gradient:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(76, 175, 80, 0.4) !important;
}

.premium-tabs ::v-deep .v-tab {
  text-transform: none;
  font-size: 0.9rem;
  @media (min-width: 600px) {
    font-size: 1.1rem;
  }
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}
.premium-tabs ::v-deep .v-tab--active {
  color: #1976D2 !important;
}

.transparent-bg {
  background-color: transparent !important;
}

.denuncia-card {
  transition: all 0.3s ease;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.denuncia-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12) !important;
  border-color: rgba(25, 118, 210, 0.3);
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 64px;
}

.respuesta-content {
  border-left: 4px solid #1976D2;
  line-height: 1.6;
}

.opacity-30 {
  opacity: 0.3;
}

.glass-input ::v-deep .v-input__slot {
  background: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 2px 10px rgba(0,0,0,0.02) !important;
}
</style>
